import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IAuditEventComparisonRow } from '../organism-audit-diff-modal.component';

@Component({
    selector: 'organism-audit-diff-cell-renderer',
    standalone: true,
    templateUrl: './organism-audit-diff-cell-renderer.component.html',
    styleUrl: './organism-audit-diff-cell-renderer.component.scss',
    host: {
        '[class.bg-diff-removed]': 'isDiffRemoved',
        '[class.bg-diff-added]': 'isDiffAdded',
        '[class.border-right]': 'hasBorderRight',
    },
})
export class OrganismAuditDiffCellRendererComponent
    implements ICellRendererAngularComp
{
    public params: ICellRendererParams<IAuditEventComparisonRow>;

    get isDiffRemoved() {
        return (
            this.params?.colDef?.field === 'preValue' &&
            this.params?.data?.isDifferent
        );
    }

    get isDiffAdded() {
        return (
            this.params?.colDef?.field === 'postValue' &&
            this.params?.data?.isDifferent
        );
    }

    get hasBorderRight() {
        return this.params?.colDef?.field === 'preValue';
    }

    agInit(params: ICellRendererParams<IAuditEventComparisonRow>): void {
        this.params = params;
    }

    refresh(params: ICellRendererParams<IAuditEventComparisonRow>): boolean {
        this.params = params;
        return true;
    }
}
